import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import { translate } from "@classdojo/web/utils/translate";

export const TABLE_TOPICS = () => ({
  description: translate("dojo.beyond:toolkit.table_topics.description"),
  pageUrl: "/beyondToolkit/tableTopics",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/107.png",
  imgSrc: "/static/images/toolkit_table_topics.png",
  loggingId: "table_topics",
  unlocked: true,
  title: translate("dojo.beyond:toolkit.apps.dinner_topics"),
  color: "dt_content_accent" as NessieThemeColors,
});

export const TIMER = () => ({
  description: translate("dojo.beyond:toolkit.timer.description"),
  pageUrl: "/beyondToolkit/timer",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/42.png",
  imgSrc: "/static/images/toolkit_timer.png",
  loggingId: "timer",
  title: translate("dojo.beyond:toolkit.apps.timer"),
  color: "dt_blueberry50",
  unlocked: true,
});

export const MINDFULNESS = () => ({
  description: translate("dojo.beyond:toolkit.mindfulness.description"),
  pageUrl: "/beyondToolkit/mindfulness",
  imgSrc: "/static/images/toolkit_mindfulness.png",
  loggingId: "mindfulness",
  unlocked: true,
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/55.png",
  title: translate("dojo.beyond:toolkit.apps.bedtime_meditations"),
  color: "#4e10eb" as NessieThemeColors,
});

export const BEDTIME_STORIES = () => ({
  title: translate("dojo.beyond:toolkit.apps.bedtime_stories"),
  description: translate("dojo.beyond:toolkit.bedtime_stories.description"),
  pageUrl: "/beyondToolkit/bedtimeStories",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/53.png",
  imgSrc: "/static/images/toolkit_bedtime.png",
  color: "dt_content_plus",
  loggingId: "bedtime",
  unlocked: true,
});

export const READ_ALONGS = () => ({
  title: translate("dojo.beyond:toolkit.apps.read_alongs"),
  description: translate("dojo.beyond:toolkit.read_alongs.description"),
  pageUrl: "/beyondToolkit/readAlongs",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  imgSrc: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  background: "linear-gradient(79.76deg, #1EF1A5 -28.69%, #3388D7 141.03%)",
  color: "#194BE0",
  loggingId: "read_alongs",
  unlocked: true,
});

export const MUSIC = () => ({
  description: translate("dojo.beyond:toolkit.music.description"),
  pageUrl: "/beyondToolkit/music",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/86.png",
  imgSrc: "/static/images/toolkit_music.png",
  loggingId: "music",
  unlocked: true,
  title: translate("dojo.beyond:toolkit.apps.sleep_music"),
  color: "#194BE0",
});

export const WHOSE_TURN = () => ({
  description: translate("dojo.beyond:toolkit.whose_turn.description"),
  pageUrl: "/beyondToolkit/whoseTurn",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/137.png",
  loggingId: "whose_turn",
  unlocked: true,
  title: translate("dojo.beyond:toolkit.apps.whose_turn_no_q"),
  color: "dt_content_danger",
  imgSrc: "/static/images/toolkit_whose_turn.png",
});

export const BRUSH_TEETH = () => ({
  description: translate("dojo.beyond:toolkit.brush_teeth.description"),
  pageUrl: "/beyondToolkit/brushTeeth",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/88.png",
  loggingId: "brush_teeth",
  unlocked: true,
  title: translate("dojo.beyond:toolkit.apps.brush_teeth"),
  background: "linear-gradient(171.67deg, #75B4FF 5.98%, #DD519E 93.98%)",
  duration: 119,
  mainAudio: "/static/media/activity-brushteeth_song.mp3",
});

export const SHAKE_SILLIES = () => ({
  description: translate("dojo.beyond:toolkit.shake_sillies.description"),
  pageUrl: "/beyondToolkit/shakeSillies",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/119.png",
  loggingId: "shake_sillies",
  unlocked: true,
  title: translate("dojo.beyond:toolkit.apps.shake_sillies"),
  color: "rgb(84,223,207)" as NessieThemeColors,
  background: "linear-gradient(177.77deg, #FFCB69 8.36%, #EF4EAF 146.44%)",
  duration: 177,
  mainAudio: "/static/media/activity-wiggleit_song.mp3",
});
